import { useNavigate } from "react-router";
import { CreateOrderForm } from "@/features/orders/create-order-form";
import { logger } from "@/services/logger";

export default function OnboardingStep2Screen() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col flex-1">
      <CreateOrderForm
        onSuccess={async () => {
          await navigate("/onboarding/success");
        }}
        onError={(error) => {
          logger.error("Error creating order:", error);
        }}
      />
    </div>
  );
}
